import { defineStore } from 'pinia'
import { ref, computed } from 'vue'

import { meApi } from '@/api/modules/me'
import { authApi } from '@/api/modules/auth'

export interface CurrentUser {
  id: string
  email: string
  display_name: string
  locale: string
  time_zone: string
  is_superadmin: boolean
  mfa_enabled?: boolean
  partner_id?: string
  organization_id?: string
  permissions: string[]
}

export const useAuthStore = defineStore('auth', () => {
  const user = ref<CurrentUser | null>(null)
  const loaded = ref(false)

  const isAuthenticated = computed(() => user.value !== null)
  const has = (perm: string) =>
    !!user.value &&
    (user.value.permissions.includes('admin:*') || user.value.permissions.includes(perm))

  async function loadMe(): Promise<void> {
    try {
      const me = await meApi.get()
      user.value = me
    } catch {
      user.value = null
    } finally {
      loaded.value = true
    }
  }

  async function login(email: string, password: string, code?: string): Promise<void> {
    await authApi.login(email, password, code)
    await loadMe()
  }

  async function logout(): Promise<void> {
    await authApi.logout()
    user.value = null
  }

  return { user, loaded, isAuthenticated, has, loadMe, login, logout }
})
